import { EmptyPanel } from './ui/index.js'

function EmptyState({ action, icon, title, message }) {
  return (
    <EmptyPanel
      action={action}
      icon={icon}
      message={message}
      title={title}
    />
  )
}

export default EmptyState
